import type { AABB, Faction } from '../game/ontology';

// Hitbox — the offensive AABB an Actor projects during an attack Loop. It is
// only "live" for the strike window, carries the attacker's Faction so it never
// lands on its own team, and remembers which Hurtboxes it already struck this
// swing so one attack registers once per target.

let nextId = 1;

export class Hitbox {
  readonly id: number = nextId++;
  readonly faction: Faction;
  /** The owning Actor's id, so a Hitbox never resolves against its own Hurtbox. */
  readonly ownerId: number;
  /** Live world-space AABB, refreshed each frame by the owner. */
  box: AABB;
  /** Only resolved while active (the attack's strike window). */
  active = false;
  /** Hurtbox ids already struck during the current activation. */
  private struck = new Set<number>();

  constructor(ownerId: number, faction: Faction, box: AABB) {
    this.ownerId = ownerId;
    this.faction = faction;
    this.box = box;
  }

  /** Open the strike window (start of the attack loop's active frames). */
  activate(): void {
    this.active = true;
    this.struck.clear();
  }

  deactivate(): void {
    this.active = false;
    this.struck.clear();
  }

  hasStruck(hurtboxId: number): boolean {
    return this.struck.has(hurtboxId);
  }

  markStruck(hurtboxId: number): void {
    this.struck.add(hurtboxId);
  }
}
